<div class="wetter_content_container">
<!--  <h3>Aussichten (Langwetter)</h3>-->
<!--  <div class="bericht-text-container">-->
<!--        <span-->
<!--          class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag02?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag02?.kurzbeschreibung}}</p>-->
<!--    <span-->
<!--      class="bericht-text-sub-label">{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag02?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag02?.kurzbeschreibung}}</p>-->

<!--  </div>-->

<!--  <div class="bericht-text-container">-->
<!--       <span-->
<!--         class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag03?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag03?.kurzbeschreibung}}</p>-->
<!--    <span-->
<!--      class="bericht-text-sub-label">{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag03?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag03?.kurzbeschreibung}}</p>-->

<!--  </div>-->
<!--  <div class="bericht-text-container">-->
<!--        <span-->
<!--          class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag04?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag04?.kurzbeschreibung}}</p>-->
<!--    <span-->
<!--      class="bericht-text-sub-label">{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag04?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag04?.kurzbeschreibung}}</p>-->

<!--  </div>-->
<!--  <div class="bericht-text-container">-->
<!--    <span-->
<!--      class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag05?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag05?.kurzbeschreibung}}</p>-->
<!--    <span-->
<!--      class="bericht-text-sub-label">{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag05?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag05?.kurzbeschreibung}}</p>-->

<!--  </div>-->
<!--  <div class="bericht-text-container">-->
<!--    <span-->
<!--      class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag06?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.nachtZuTag06?.kurzbeschreibung}}</p>-->
<!--    <span-->
<!--      class="bericht-text-sub-label">{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag06?.datum | date: 'EEE dd.MM'}}</span>-->
<!--    <p>{{berlinBrandenburgOnlineBericht?.langwetterAussichten?.tag06?.kurzbeschreibung}}</p>-->
<!--  </div>-->
  <h3>Vorhersagen (Langwetter) </h3>
  <div class="bericht-text-container">
    <span
      class="bericht-text-sub-label">{{berlinBrandenburgOnlineBericht?.langwetterVorhersage?.tag00?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{berlinBrandenburgOnlineBericht?.langwetterVorhersage?.tag00?.kurzbeschreibung}}</p>
  </div>
  <div class="bericht-text-container">
        <span
          class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgOnlineBericht?.langwetterVorhersage?.nachtZuTag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{berlinBrandenburgOnlineBericht?.langwetterVorhersage?.nachtZuTag01?.kurzbeschreibung}}</p>
    <span
      class="bericht-text-sub-label">{{berlinBrandenburgOnlineBericht?.langwetterVorhersage?.tag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{berlinBrandenburgOnlineBericht?.langwetterVorhersage?.tag01?.kurzbeschreibung}}</p>
  </div>
</div>
